import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { formatDatePublish } from '../../utils';

import { Multitenant } from 'src/app/services/multitenant.provider';
import { ConfigService } from 'src/app/services/config.service';
import { StorageProvider } from 'src/app/services/storage.provider';

import { Archive } from 'src/app/models/archive.model';
import { GaEventTrackerProvider } from 'src/app/services/gaeventtracker.provider';


@Component({
  selector: 'app-newspaper-pdf',
  templateUrl: './newspaper-pdf.html',
  styleUrls: ['./newspaper-pdf.scss']
})
export class NewspaperPdfComponent implements OnInit {
  @HostBinding('class') newspaper_subname: string = this.multiTenant.getDomainClass();

  @Input() category: string;
  @Input() themeClass: string;
  @Input() pdf: Archive;

  public formatDatePublish = formatDatePublish;
  public accessToken: string;
  public profileId: string;

  constructor(private multiTenant: Multitenant, public config: ConfigService,  private storage: StorageProvider, private gaService: GaEventTrackerProvider) {}

  ngOnInit(): void {
    if (this.storage.getStorage('access_token')) {
      this.accessToken = this.storage.getStorage('access_token');
    }
    if (this.storage.getStorage('logged_profile_id')) {
      this.profileId = this.storage.getStorage('logged_profile_id');
    }
  }

  public downloadPdf(archive: Archive) {
    this.gaService.sendPDFDownloadReader(archive, 'download');
    const pdfUrl = this.config.getApiDomainByEnv() + '/download?media=' + archive.pdf_id + '&entity=newspaperPdf&forcePdf=1&access_token=' +
      this.accessToken + '&newspaperSubname=' + archive.newspaper_subname + '&profil=' + this.profileId;

      window.open(pdfUrl , '_blank');
  }

  public getOrdinalNum(n) {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return s[(v - 20) % 10] || s[v] || s[0];
  }
}
